import { render } from "./CHistory.vue?vue&type=template&id=7d9d6698&scoped=true"
import script from "./CHistory.vue?vue&type=script&lang=js"
export * from "./CHistory.vue?vue&type=script&lang=js"

import "./CHistory.vue?vue&type=style&index=0&id=7d9d6698&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9d6698"]])

export default __exports__